import React, { useState, useMemo, useCallback } from 'react';
import { useMenuData } from '../data/menuData';
import MenuCard, { ExpandedCardProvider } from './MenuCard';

// import { measurePerformance } from '../utils/performance';

const MenuSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const { menuItems, menuCategories, loading } = useMenuData();
  
  // console.log("menuItems are", menuItems);
  

  // Use default data if Firebase data is not loaded yet
  const currentMenuItems = menuItems;
  const currentMenuCategories = menuCategories;

  const filteredItems = useMemo(() => {
    // return measurePerformance('Menu filtering', () => {
    //   return selectedCategory === 'all' 
    //     ? currentMenuItems 
    //     : currentMenuItems.filter(item => item.category === selectedCategory);
    // }); for  performance testing
    return selectedCategory === 'all' 
      ? currentMenuItems 
      : currentMenuItems.filter(item => item.category === selectedCategory);
  }, [selectedCategory, currentMenuItems]);

  const handleCategoryChange = useCallback((categoryId) => {
    setSelectedCategory(categoryId);
  }, []);

  return (
    <section id="menu" className="py-20 bg-gradient-to-br from-[#F8E8D2]/20 via-white to-[#F8E8D2]/20">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-segoe font-bold text-gray-800 mb-4">Our Signature Menu</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Handcrafted dishes with love and tradition</p>
        </div>
        
        {/* Menu Categories */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8 sm:mb-12">
          {currentMenuCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryChange(category.id)}
              className={`category-btn px-3 sm:px-4 md:px-6 py-2 sm:py-3 border-2 border-secondary rounded-full font-medium transition-all duration-200 hover:scale-105 text-xs sm:text-sm md:text-base ${
                selectedCategory === category.id 
                  ? 'active bg-primary text-black' 
                  : 'bg-transparent text-black hover:bg-primary hover:text-gray-700'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Menu Grid */}
        <ExpandedCardProvider>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-6">
            {filteredItems.map(item => (
              <MenuCard key={item.id} item={item} />
            ))}
          </div>
        </ExpandedCardProvider>
      </div>
    </section>
  );
};

export default MenuSection; 